// jQuery(document).ready(function($) {

//     const $main = $('.ranker_main-slider');
//     const $thumbImgs = $(".thumb img");
//     const totalSlides = $main.children().length;
//     if (totalSlides <= 1) {
//         console.log("Single image detected → Slider disabled.");
//         $(".thumb-grid").hide();
//         return;
//     }
//     $main.slick({
//         arrows: true,
//         dots: false,
//         infinite: true,
//         speed: 350,
//         slidesToShow: 1,
//         adaptiveHeight: true,
//         autoplay: true,
//         autoplaySpeed: 3000,
//         pauseOnHover: true,
//         pauseOnFocus: true
//     });
//     function setActiveThumb(index) {
//         $thumbImgs.removeClass("active-thumb");
//         $thumbImgs.eq(index).addClass("active-thumb");
//     }
//     setActiveThumb(0);
//     $(document).on("click", ".thumb", function() {
//         let index = $(this).data("slide");
//         $main.slick("slickGoTo", index);
//         setActiveThumb(index);
//     });
//     $main.on('afterChange', function(event, slick, currentSlide) {
//         setActiveThumb(currentSlide);
//     });
//     GLightbox({
//         selector: ".glightbox",
//         touchNavigation: true,
//         loop: true
//     });

// });

jQuery(document).ready(function($) {

    const $main = $('.ranker_main-slider');
    const totalSlides = $main.children().length;

    if (totalSlides <= 1) {
        $(".thumb-grid").hide();
        return;
    }

    $main.slick({
        arrows: true,
        dots: false,
        infinite: true,
        speed: 350,
        slidesToShow: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        pauseOnFocus: true
    });

    function setActiveThumb(index) {
        $(".thumb").removeClass("active-thumb");
        $(".thumb").eq(index).addClass("active-thumb");
    }

    setActiveThumb(0);

    $(document).on("click", ".thumb", function() {
        let index = $(this).data("slide");
        $main.slick("slickGoTo", index);
    });

    $main.on('afterChange', function(event, slick, currentSlide) {

        setActiveThumb(currentSlide);

        // Pause all videos
        $('.ranker-slide video').each(function() {
            this.pause();
        });

        // Play only current slide video
        let $currentSlide = $(slick.$slides[currentSlide]);
        let video = $currentSlide.find("video").get(0);

        if (video) {
            video.play();
        }
    });

    GLightbox({
        selector: ".glightbox",
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    });

});
